import { render } from "./DTextField.vue?vue&type=template&id=706be3d4&lang=pug"
import script from "./DTextField.vue?vue&type=script&lang=js"
export * from "./DTextField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__